import { WorkflowObjectTypes } from '@generated/graphql';
import { PageObjectType } from '@pages/setting/PageConfigurationDetail/pageConfigurationTypes';
import type { TabWorkflowUserParams } from './resolveTabWorkflowUser';

// A page missing here only launches USER workflows; a household page launches
// HOUSEHOLD from its tabs, which the launch builder handles separately.
export const PAGE_ROOT_WORKFLOW_OBJECT_TYPE: Readonly<
  Partial<Record<PageObjectType, WorkflowObjectTypes>>
> = {
  [PageObjectType.ACCOUNT]: WorkflowObjectTypes.Account,
  [PageObjectType.GOAL]: WorkflowObjectTypes.Goal,
  [PageObjectType.SUB_ACCOUNT]: WorkflowObjectTypes.SubAccount,
};

export const isPageRootedWorkflowPage = (pageType?: PageObjectType) =>
  !!pageType && pageType in PAGE_ROOT_WORKFLOW_OBJECT_TYPE;

export const getPageObjectId = ({
  pageType,
  objectId,
  accountId,
  goalId,
  subAccountId,
  clientGroupId,
}: TabWorkflowUserParams) => {
  switch (pageType) {
    case PageObjectType.ACCOUNT:
      return accountId || objectId;
    case PageObjectType.GOAL:
      return goalId || objectId;
    case PageObjectType.SUB_ACCOUNT:
      return subAccountId || objectId;
    case PageObjectType.HOUSEHOLD:
      return clientGroupId || objectId;
    default:
      return undefined;
  }
};
